export const PRODUCT_SIZES = ['L', 'XL', '2XL', '3XL', '4XL', '5XL', '6XL', '7XL'];

export const IMAGE_ASPECT_CLASS = 'aspect-[4/5]';
export const PRODUCT_IMAGE_WIDTH = 1200;
export const PRODUCT_IMAGE_HEIGHT = 1500;

export const sortSizes = (sizes = []) =>
  [...sizes].sort((a, b) => PRODUCT_SIZES.indexOf(a) - PRODUCT_SIZES.indexOf(b));
